import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxCurrencyWrapperModule } from '../../../shared/ngx-currency-wrapper.module';
import { MaterialModule } from '../../../shared/material/material.module';
import { ReusableMerchantTemplate } from './reusable-merchant-template';

@NgModule({
    declarations: [ReusableMerchantTemplate],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxCurrencyWrapperModule,
    ],
    exports: [ReusableMerchantTemplate]
})
export class ReusableMerchantTemplateModule {}